import { Component, OnDestroy, signal, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { LOREN_ROUTES } from "../../../shared/constants/loren-routes.constants";
import { LorenPrivilegeEntityType } from "../interfaces/loren-role.interface";
import { LorenBaseFeature } from "../../../shared/base-components/loren-base-feature/loren-base-feature";
import { LorenRoleService } from "../services/loren-role.service";
import { LorenDetailsOutletService } from "../../../shared/services/loren-details-outlet-service/loren-details-outlet.service";

@Component({
  selector: "loren-role",
  templateUrl: "./loren-role.component.html",
  styleUrls: ["./loren-role.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LorenRoleComponent extends LorenBaseFeature implements OnDestroy, OnInit {
  private detailsOutletService = inject(LorenDetailsOutletService);
  private lorenUserRoleService = inject(LorenRoleService);

  roles = signal(null);
  loading = signal<boolean>(false);
  error = signal<boolean>(false);
  selectionValue;
  readonly privileges = LorenPrivilegeEntityType;

  ngOnInit() {
    this.loading.set(true);
    this.lorenUserRoleService.allRoles$.subscribe({
      next: (res) => {
        this.roles.set(res);
        this.loading.set(false);
        this.error.set(false);
      },
      error: () => {
        this.loading.set(false);
        this.error.set(false);
      },
    });
    this.lorenUserRoleService.selectedRole$.subscribe((x) => {
      if (!x) {
        this.selectionValue = null;
      }
    });
  }

  ngOnDestroy() {
    this.detailsOutletService.toggleState(false);
  }

  handleCreate() {
    this.openRoleForm();
  }

  handleEdit(event) {
    const role = event.options[0].value;
    this.openRoleForm(role);
  }

  private openRoleForm(role = null) {
    this.lorenUserRoleService.selectedRole$.next(role);

    this.detailsOutletService.resetDetailsOutlet();
    setTimeout(() => {
      this.detailsOutletService.toggleState(true);
      this.detailsOutletService.navigate(`${LOREN_ROUTES.ROLES_FORM}`);
    }, 1);
  }
}
